var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.getDemandList,
          expression: "getDemandList",
        },
      ],
      staticClass: "container-fluid infinite-list",
      attrs: {
        "infinite-scroll-immediate": "false",
        "infinite-scroll-disabled": "disabled",
      },
    },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺單號")]),
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "請輸入關鍵字" },
                    model: {
                      value: _vm.searchCondition.ManpowerDemandNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "ManpowerDemandNo", $$v)
                      },
                      expression: "searchCondition.ManpowerDemandNo",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺名稱")]),
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "請輸入關鍵字" },
                    model: {
                      value: _vm.searchCondition.ManpowerDemandName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "ManpowerDemandName", $$v)
                      },
                      expression: "searchCondition.ManpowerDemandName",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.PositionCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "PositionCode", $$v)
                        },
                        expression: "searchCondition.PositionCode",
                      },
                    },
                    _vm._l(_vm.positionOptions, function (position) {
                      return _c("el-option", {
                        key: position.Code,
                        attrs: { label: position.Name, value: position.Code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v(_vm._s(_vm.i18n("Basic.ApplyDepartment"))),
                  ]),
                  _c("treeselect", {
                    attrs: {
                      options: _vm.departmentOptions,
                      searchable: true,
                      "show-count": true,
                      "default-expand-level": 1,
                      placeholder: "請選擇",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "option-label",
                        fn: function ({
                          node,
                          shouldShowCount,
                          count,
                          labelClassName,
                          countClassName,
                        }) {
                          return _c(
                            "label",
                            { class: labelClassName, attrs: { for: "" } },
                            [
                              _vm._v(" " + _vm._s(node.label) + " "),
                              shouldShowCount
                                ? _c("span", { class: countClassName }, [
                                    _vm._v(" (" + _vm._s(count) + ") "),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        },
                      },
                    ]),
                    model: {
                      value: _vm.searchCondition.demandDepartmentGuid,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchCondition,
                          "demandDepartmentGuid",
                          $$v
                        )
                      },
                      expression: "searchCondition.demandDepartmentGuid",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("申請人")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.ApplicantGuid,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchCondition, "ApplicantGuid", $$v)
                        },
                        expression: "searchCondition.ApplicantGuid",
                      },
                    },
                    _vm._l(_vm.employeeOptions, function (employee) {
                      return _c("el-option", {
                        key: employee.Guid,
                        attrs: { label: employee.Name, value: employee.Guid },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("職缺狀態")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        clearable: "",
                        multiple: "",
                        "value-key": "Key",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.searchCondition.ManpowerDemandStatus,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchCondition,
                            "ManpowerDemandStatus",
                            $$v
                          )
                        },
                        expression: "searchCondition.ManpowerDemandStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (status) {
                      return _c("el-option", {
                        key: status.Key,
                        attrs: { label: status.Value, value: status },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-12 col-md-6" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      ;(_vm.clickSearchBtn = true), _vm.getDemandList()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.searchCondition = {}
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.openSortDialog()
                    },
                  },
                },
                [_vm._v(" 前台職缺排序 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.demandList.length > 0
        ? _c("div", { staticClass: "tool-list" }, [
            _c("div", { staticClass: "tool-list-item pop-messages pop" }, [
              _c("p", [
                _c("strong", { staticClass: "mr-3" }, [
                  _vm._v("總共：" + _vm._s(_vm.totalDemand) + " 筆"),
                ]),
                _vm.PendingQuantity !== 0
                  ? _c("strong", { staticClass: "ml-2 mr-3" }, [
                      _vm._v(" 待決：" + _vm._s(_vm.PendingQuantity) + " 筆 "),
                    ])
                  : _vm._e(),
                _vm.ApprovedQuantity !== 0
                  ? _c("strong", { staticClass: "ml-2 mr-3" }, [
                      _vm._v(" 同意：" + _vm._s(_vm.ApprovedQuantity) + " 筆 "),
                    ])
                  : _vm._e(),
                _vm.RejectedQuantity !== 0
                  ? _c("strong", { staticClass: "ml-2 mr-3" }, [
                      _vm._v(" 否決：" + _vm._s(_vm.RejectedQuantity) + " 筆 "),
                    ])
                  : _vm._e(),
                _vm.SuspendQuantity !== 0
                  ? _c("strong", { staticClass: "ml-2 mr-3" }, [
                      _vm._v(" 停用：" + _vm._s(_vm.SuspendQuantity) + " 筆 "),
                    ])
                  : _vm._e(),
                _vm.CancelledQuantity !== 0
                  ? _c("strong", { staticClass: "ml-2" }, [
                      _vm._v(
                        " 作廢：" + _vm._s(_vm.CancelledQuantity) + " 筆 "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "tool-list-about-card" }, [
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "block" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "block"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "grid-outline" },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "list" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "list"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "list-outline" },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "demand-card-list",
          class: {
            "list-style": _vm.gridStyle === "list",
            "block-style": _vm.gridStyle === "block",
          },
        },
        _vm._l(_vm.demandList, function (demand) {
          return _c(
            "div",
            { key: demand.Guid, staticClass: "demand-card infinite-list-item" },
            [
              _c("DemandCard", {
                ref: "demandCard",
                refInFor: true,
                attrs: {
                  category: "search",
                  showCheckbox: false,
                  data: demand,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "search",
                      fn: function ({ props }) {
                        return [
                          props.ManpowerDemandStatus === "Approved" ||
                          props.ManpowerDemandStatus === "Suspend"
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getDemandDetail(props.Guid)
                                      },
                                    },
                                  },
                                  [_vm._v(" 編輯 ")]
                                ),
                              ]
                            : _vm._e(),
                          props.ManpowerDemandStatus === "Approved"
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.suspendDemand(props.Guid)
                                      },
                                    },
                                  },
                                  [_vm._v(" 停用 ")]
                                ),
                              ]
                            : _vm._e(),
                          props.ManpowerDemandStatus === "Suspend"
                            ? [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.rebootDemand(props.Guid)
                                      },
                                    },
                                  },
                                  [_vm._v(" 啟用 ")]
                                ),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "editModal",
            tabindex: "-1",
            "aria-labelledby": "exampleModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("p", [_vm._v("編輯職缺")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 職缺名稱 "),
                                ]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.edit.ManpowerDemandName,
                                      expression: "edit.ManpowerDemandName",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: _vm.edit.ManpowerDemandName,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.edit,
                                        "ManpowerDemandName",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 需求人數 "),
                                ]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: _vm.edit.DemandNumber,
                                      expression: "edit.DemandNumber",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number", min: "1" },
                                  domProps: { value: _vm.edit.DemandNumber },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.edit,
                                        "DemandNumber",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 招募期限 "),
                                  ]),
                                  _c("date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      valueType: "format",
                                    },
                                    model: {
                                      value: _vm.edit.RecruitmentDeadline,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.edit,
                                          "RecruitmentDeadline",
                                          $$v
                                        )
                                      },
                                      expression: "edit.RecruitmentDeadline",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 工作地點 "),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("multiselect", {
                                                attrs: {
                                                  options: _vm.workplaceOptions,
                                                  "close-on-select": false,
                                                  multiple: true,
                                                  selectLabel: "",
                                                  selectedLabel: "",
                                                  deselectLabel: "",
                                                  "track-by": "WorkPlaceGuid",
                                                  label: "WorkPlace",
                                                  placeholder: "請選擇",
                                                },
                                                model: {
                                                  value:
                                                    _vm.edit
                                                      .ManpowerDemandWorkPlace,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.edit,
                                                      "ManpowerDemandWorkPlace",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "edit.ManpowerDemandWorkPlace",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger ml-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-check-label",
                                          attrs: { for: "" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#ff0000" },
                                            },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" 學歷 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.edit
                                                    .EducationDemandWhatever,
                                                expression:
                                                  "edit.EducationDemandWhatever",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.edit.EducationDemandWhatever
                                              )
                                                ? _vm._i(
                                                    _vm.edit
                                                      .EducationDemandWhatever,
                                                    null
                                                  ) > -1
                                                : _vm.edit
                                                    .EducationDemandWhatever,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.edit
                                                      .EducationDemandWhatever,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "EducationDemandWhatever",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "EducationDemandWhatever",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.edit,
                                                    "EducationDemandWhatever",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v("不拘 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  !_vm.edit.EducationDemandWhatever
                                    ? [
                                        _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("multiselect", {
                                                      attrs: {
                                                        options:
                                                          _vm.educationDegreeOptions,
                                                        "close-on-select": false,
                                                        multiple: true,
                                                        selectLabel: "",
                                                        selectedLabel: "",
                                                        deselectLabel: "",
                                                        "track-by":
                                                          "EducationDegreeGuid",
                                                        label:
                                                          "EducationDegree",
                                                        placeholder: "請選擇",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.edit
                                                            .ManpowerDemandEducationDegree,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "ManpowerDemandEducationDegree",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "edit.ManpowerDemandEducationDegree",
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-check-label",
                                          attrs: { for: "" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#ff0000" },
                                            },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" 工作經驗 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.edit
                                                    .WorkExperienceWhatever,
                                                expression:
                                                  "edit.WorkExperienceWhatever",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.edit.WorkExperienceWhatever
                                              )
                                                ? _vm._i(
                                                    _vm.edit
                                                      .WorkExperienceWhatever,
                                                    null
                                                  ) > -1
                                                : _vm.edit
                                                    .WorkExperienceWhatever,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.edit
                                                      .WorkExperienceWhatever,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "WorkExperienceWhatever",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "WorkExperienceWhatever",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.edit,
                                                    "WorkExperienceWhatever",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v("不拘 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  !_vm.edit.WorkExperienceWhatever
                                    ? [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "工作經驗",
                                            rules: "min_value:1|required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            _vm.edit
                                                              .WorkExperience,
                                                          expression:
                                                            "edit.WorkExperience",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control w-70",
                                                      attrs: {
                                                        type: "number",
                                                        min: "1",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.edit
                                                            .WorkExperience,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "WorkExperience",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 工作內容 "),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.edit.WorkContent,
                                                    expression:
                                                      "edit.WorkContent",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { rows: "10" },
                                                domProps: {
                                                  value: _vm.edit.WorkContent,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.edit,
                                                      "WorkContent",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.i18n(
                                          "DemandApply.ManagementResponsibility"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.edit.ManagementResponsibility,
                                      expression:
                                        "edit.ManagementResponsibility",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.edit.ManagementResponsibility
                                    )
                                      ? _vm._i(
                                          _vm.edit.ManagementResponsibility,
                                          null
                                        ) > -1
                                      : _vm.edit.ManagementResponsibility,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a =
                                          _vm.edit.ManagementResponsibility,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.edit,
                                              "ManagementResponsibility",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.edit,
                                              "ManagementResponsibility",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.edit,
                                          "ManagementResponsibility",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.i18n("DemandApply.Require")) +
                                    " (若勾選，請填寫管理人數) "
                                ),
                              ]),
                              _vm.edit.ManagementResponsibility
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "#ff0000" } },
                                          [_vm._v("*")]
                                        ),
                                        _vm._v(" 管理人數 "),
                                      ]),
                                      _c("ValidationProvider", {
                                        staticClass: "w-100",
                                        attrs: {
                                          rules: "min_value:1|required",
                                          name: "管理人數",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.edit
                                                            .ManagementNumber,
                                                        expression:
                                                          "edit.ManagementNumber",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control w-100",
                                                    attrs: {
                                                      type: "number",
                                                      min: "1",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.edit
                                                          .ManagementNumber,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "ManagementNumber",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("div", [
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("DemandApply.BusinessTrip")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { rules: "required", name: "出差" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.edit.BusinessTrip,
                                                        expression:
                                                          "edit.BusinessTrip",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.edit.BusinessTrip
                                                      )
                                                        ? _vm._i(
                                                            _vm.edit
                                                              .BusinessTrip,
                                                            null
                                                          ) > -1
                                                        : _vm.edit.BusinessTrip,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.edit
                                                              .BusinessTrip,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "BusinessTrip",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "BusinessTrip",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "BusinessTrip",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("DemandApply.Expat")) +
                                        " "
                                    ),
                                  ]),
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { rules: "required", name: "外派" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.edit.OverseasWork,
                                                        expression:
                                                          "edit.OverseasWork",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.edit.OverseasWork
                                                      )
                                                        ? _vm._i(
                                                            _vm.edit
                                                              .OverseasWork,
                                                            null
                                                          ) > -1
                                                        : _vm.edit.OverseasWork,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.edit
                                                              .OverseasWork,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "OverseasWork",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "OverseasWork",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "OverseasWork",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("DemandApply.Shifts")) +
                                        " "
                                    ),
                                  ]),
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { rules: "required", name: "輪班" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form-check-label",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.edit.Shift,
                                                        expression:
                                                          "edit.Shift",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.edit.Shift
                                                      )
                                                        ? _vm._i(
                                                            _vm.edit.Shift,
                                                            null
                                                          ) > -1
                                                        : _vm.edit.Shift,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.edit.Shift,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "Shift",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.edit,
                                                                "Shift",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "Shift",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n(
                                                          "DemandApply.Require"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.i18n("DemandApply.ShiftType")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _vm._l(_vm.newWorkingHours, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.WorkShiftTypeGuid,
                                        staticClass: "form-check",
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "form-check-label" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.edit
                                                      .ManpowerDemandWorkShiftType,
                                                  expression:
                                                    "edit.ManpowerDemandWorkShiftType",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: item,
                                                checked: Array.isArray(
                                                  _vm.edit
                                                    .ManpowerDemandWorkShiftType
                                                )
                                                  ? _vm._i(
                                                      _vm.edit
                                                        .ManpowerDemandWorkShiftType,
                                                      item
                                                    ) > -1
                                                  : _vm.edit
                                                      .ManpowerDemandWorkShiftType,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.edit
                                                        .ManpowerDemandWorkShiftType,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = item,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "ManpowerDemandWorkShiftType",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "ManpowerDemandWorkShiftType",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.edit,
                                                      "ManpowerDemandWorkShiftType",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(item.WorkShiftType) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.trim",
                                              value:
                                                item.WorkShiftTypeDescription,
                                              expression:
                                                "item.WorkShiftTypeDescription",
                                              modifiers: { trim: true },
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "請填寫詳細時段或排班資訊",
                                          },
                                          domProps: {
                                            value:
                                              item.WorkShiftTypeDescription,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "WorkShiftTypeDescription",
                                                $event.target.value.trim()
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 薪資類型 "),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("v-select", {
                                                staticClass: "w-100",
                                                attrs: {
                                                  options: _vm.salaryTypeList,
                                                  label: "Name",
                                                  placeholder: "請選擇",
                                                },
                                                model: {
                                                  value: _vm.salaryTypeValue,
                                                  callback: function ($$v) {
                                                    _vm.salaryTypeValue = $$v
                                                  },
                                                  expression: "salaryTypeValue",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm.salaryTypeValue &&
                                  _vm.salaryTypeValue.Code === "other"
                                    ? _c("ValidationProvider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.edit
                                                            .SalaryTypeDescription,
                                                        expression:
                                                          "edit.SalaryTypeDescription",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "請填寫薪資類型",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.edit
                                                          .SalaryTypeDescription,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "SalaryTypeDescription",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 職務聯絡人 "),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("multiselect", {
                                                staticClass: "w-100",
                                                attrs: {
                                                  options:
                                                    _vm.supervisorOptions,
                                                  placeholder: "請選擇",
                                                  label: "Name",
                                                  "track-by": "Email",
                                                  selectLabel: "",
                                                  selectedLabel: "",
                                                  deselectLabel: "",
                                                  taggable: true,
                                                },
                                                on: {
                                                  tag: _vm.addPositionContactorTag,
                                                },
                                                model: {
                                                  value:
                                                    _vm.edit.PositionContactor,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.edit,
                                                      "PositionContactor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "edit.PositionContactor",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 職務聯絡人Email "),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required|email" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.edit
                                                        .PositionContactorEmail,
                                                    expression:
                                                      "edit.PositionContactorEmail",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { type: "email" },
                                                domProps: {
                                                  value:
                                                    _vm.edit
                                                      .PositionContactorEmail,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.edit,
                                                      "PositionContactorEmail",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("DemandApply.Major")) +
                                        " "
                                    ),
                                  ]),
                                  _vm._l(
                                    _vm.edit.ManpowerDemandSchoolDepartment,
                                    function (majorItem, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "language-title" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    majorItem.SchoolDepartmentType
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "h6",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "12px",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "language-text",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        majorItem.SchoolDepartment
                                                          ? majorItem.SchoolDepartment
                                                          : null
                                                      ) +
                                                      " "
                                                  ),
                                                  majorItem.SchoolDepartmentDescription
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " ｜科系描述：" +
                                                            _vm._s(
                                                              majorItem.SchoolDepartmentDescription
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger btn-sm",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteItem(
                                                            index,
                                                            "Education"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("eva-icon", {
                                                        attrs: {
                                                          fill: "#FFF",
                                                          name: "trash-2-outline",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _vm.addMajor
                                        ? _c("AddMajor", {
                                            on: {
                                              addMajor: _vm.saveItem,
                                              addCancel: function ($event) {
                                                return _vm.cancelItem(
                                                  "Education"
                                                )
                                              },
                                            },
                                          })
                                        : _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-sm",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addItem(
                                                    "Education"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-plus",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n(
                                                      "DemandApply.Major"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(" 證照 "),
                                  ]),
                                  _c("el-cascader", {
                                    staticClass: "w-100",
                                    attrs: {
                                      options: _vm.certifications,
                                      clearable: "",
                                      filterable: "",
                                      props: _vm.props,
                                      "show-all-levels": false,
                                      "filter-method": _vm.certificationsFilter,
                                    },
                                    on: { change: _vm.certificationsChange },
                                    model: {
                                      value: _vm.chooseCertifications,
                                      callback: function ($$v) {
                                        _vm.chooseCertifications = $$v
                                      },
                                      expression: "chooseCertifications",
                                    },
                                  }),
                                  _vm.certificateOther
                                    ? _c("ValidationProvider", {
                                        attrs: {
                                          tag: "section",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.certificateDescription,
                                                        expression:
                                                          "certificateDescription",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control mt-2",
                                                    attrs: { rows: "5" },
                                                    domProps: {
                                                      value:
                                                        _vm.certificateDescription,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.certificateDescription =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(" 其他條件 "),
                                ]),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.edit.OtherConditions,
                                      expression: "edit.OtherConditions",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "3", maxlength: "500" },
                                  domProps: { value: _vm.edit.OtherConditions },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.edit,
                                        "OtherConditions",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(" 薪資待遇 "),
                                ]),
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          tag: "section",
                                          name: "薪資待遇(低)",
                                          rules: {
                                            regex: new RegExp(/^([0-9,]+)$/),
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value:
                                                          _vm.edit.SalaryLow,
                                                        expression:
                                                          "edit.SalaryLow",
                                                        modifiers: {
                                                          trim: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control text-right",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value: _vm.edit.SalaryLow,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "SalaryLow",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" ~ "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          tag: "section",
                                          name: "薪資待遇(高)",
                                          rules: {
                                            regex: new RegExp(/^([0-9,]+)$/),
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value:
                                                          _vm.edit.SalaryHigh,
                                                        expression:
                                                          "edit.SalaryHigh",
                                                        modifiers: {
                                                          trim: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control text-right",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value:
                                                        _vm.edit.SalaryHigh,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "SalaryHigh",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#ff0000" } },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" 預設身份別 "),
                                  ]),
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: {
                                      name: "預設身份別",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "請選擇",
                                                    disabled:
                                                      !_vm.$Permission
                                                        .Appointment
                                                        .DLPermission.IsValid,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.edit
                                                        .AppointmentDefaultIdentityType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.edit,
                                                        "AppointmentDefaultIdentityType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "edit.AppointmentDefaultIdentityType",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "IDL",
                                                      value: "IDL",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "IDL工讀生",
                                                      value: "IDL工讀生",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "DL",
                                                      value: "DL",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "按摩師",
                                                      value: "按摩師",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        "DL產學合作4+2產學生(高中畢業)",
                                                      value:
                                                        "DL產學合作4+2產學生(高中畢業)",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        "DL產學合作1年期實習生(大四學生)",
                                                      value:
                                                        "DL產學合作1年期實習生(大四學生)",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "外籍",
                                                      value: "外籍",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.edit.ResumeType === "DL"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v(" 預設職稱 "),
                                        ]),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: {
                                              placeholder: "請選擇",
                                              disabled:
                                                !_vm.$Permission.Appointment
                                                  .DLPermission.IsValid,
                                            },
                                            model: {
                                              value:
                                                _vm.edit
                                                  .AppointmentDefaultPosition,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "AppointmentDefaultPosition",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "edit.AppointmentDefaultPosition",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "生產助理員",
                                                value: "生產助理員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "助理",
                                                value: "助理",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "技術助理員",
                                                value: "技術助理員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "技術員",
                                                value: "技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "高級技術員",
                                                value: "高級技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "事務員",
                                                value: "事務員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "資深技術員",
                                                value: "資深技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "組長",
                                                value: "組長",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "儲備組長",
                                                value: "儲備組長",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "工讀生",
                                                value: "工讀生",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "實習生",
                                                value: "實習生",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "按摩師",
                                                value: "按摩師",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v(" 預設職等 "),
                                        ]),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: {
                                              placeholder: "請選擇",
                                              disabled:
                                                !_vm.$Permission.Appointment
                                                  .DLPermission.IsValid,
                                            },
                                            model: {
                                              value:
                                                _vm.edit.AppointmentDefaultRank,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "AppointmentDefaultRank",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "edit.AppointmentDefaultRank",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: { label: "1", value: "1" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "2", value: "2" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "2.1",
                                                value: "2.1",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "2.2",
                                                value: "2.2",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "3", value: "3" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "4", value: "4" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "5", value: "5" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "6", value: "6" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "6.3",
                                                value: "6.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "7", value: "7" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "7.3",
                                                value: "7.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "8", value: "8" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "8.3",
                                                value: "8.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "9", value: "9" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "9.3",
                                                value: "9.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10",
                                                value: "10",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.3",
                                                value: "10.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.5",
                                                value: "10.5",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.7",
                                                value: "10.7",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11",
                                                value: "11",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11.3",
                                                value: "11.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11.5",
                                                value: "11.5",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "12",
                                                value: "12",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "13",
                                                value: "13",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "13.3",
                                                value: "13.3",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v(" 預設薪資 "),
                                        ]),
                                        _c("ValidationProvider", {
                                          attrs: {
                                            name: "預設薪資",
                                            rules: {
                                              regex: new RegExp(/^([0-9,]+)$/),
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.trim",
                                                          value:
                                                            _vm.edit
                                                              .AppointmentDefaultSalary,
                                                          expression:
                                                            "edit.AppointmentDefaultSalary",
                                                          modifiers: {
                                                            trim: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control text-right",
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          !_vm.$Permission
                                                            .Appointment
                                                            .DLPermission
                                                            .IsValid,
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.edit
                                                            .AppointmentDefaultSalary,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.edit,
                                                            "AppointmentDefaultSalary",
                                                            $event.target.value.trim()
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    errors[0]
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  errors[0]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                              },
                              [_vm._v(" 取消 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.editDemand)
                                  },
                                },
                              },
                              [_vm._v(" 儲存 ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("DemandDetailModal"),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "sortModal", tabindex: "-1", "data-backdrop": "static" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "d-list",
                        attrs: { list: _vm.openingOptions },
                      },
                      _vm._l(_vm.openingOptions, function (element, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "d-item",
                            attrs: { title: element.ManpowerDemandName },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                " " +
                                _vm._s(element.ManpowerDemandName) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" 關閉 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.saveSort()
                        },
                      },
                    },
                    [_vm._v(" 確定 ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("前台職缺排序")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }